import React from "react";
import PropTypes from "prop-types";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import Button from "../Button/Button";
import styles from "./QuestionFooter.module.scss";

function QuestionFooter(props) {
  const {
    handleNext,
    handleBack,
    handleSubmit,
    backDisabled,
    nextHidden,
    progress,
    questions,
    currentQuestion,
  } = props;
  const indexOfQuestion = questions.findIndex(
    (q) => q.id === currentQuestion.id
  );
  const atFinish = progress === 100 && indexOfQuestion + 1 === questions.length;
  return (
    <div className={styles.footer}>
      <ButtonGroup justify="space-between" variant={["outline", "filled"]}>
        <Button
          iconLeft="GtArrowLeft"
          className={styles.button}
          onClick={handleBack}
          isDisabled={backDisabled}
        >
          Back
        </Button>
        {!nextHidden && currentQuestion.answer !== "" ? (
          <Button
            iconRight="GtArrowRight"
            className={styles.button}
            onClick={handleNext}
          >
            Next
          </Button>
        ) : atFinish ? (
          <Button
            iconRight="GtCheckmark"
            className={styles.button}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        ) : null}
      </ButtonGroup>
    </div>
  );
}

export default QuestionFooter;

QuestionFooter.propTypes = {
  backDisabled: PropTypes.bool,
  currentQuestion: PropTypes.shape({
    answer: PropTypes.string,
    dimension: PropTypes.string,
    id: PropTypes.number,
    question: PropTypes.string,
    subDimension: PropTypes.string,
  }),
  handleBack: PropTypes.func,
  handleNext: PropTypes.func,
  handleSubmit: PropTypes.func,
  nextHidden: PropTypes.bool,
  progress: PropTypes.number,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      dimension: PropTypes.string,
      id: PropTypes.number,
      question: PropTypes.string,
      subDimension: PropTypes.string,
    })
  ),
};
